<template>
  <div id="ag-grid-demo">
                <vx-card>
            <div class="header_side">
                <div class="header_side_select">
                    <per-page
                    :currentPerPage="per_page"
                    :pageStart="pageStart"
                    :pageEnd="pageEnd"
                    :total="total"
          @change-per-page="ChangePerPage($event)"
        />
                </div>
                <div class="header_side_buttons">
                    <vs-button
                        class="mt-3 w-auto"
                    >Release Selected</vs-button>
                    <vs-button
                        class="mt-3"
                        @click="openNumberPage"
                    >Buy Number</vs-button>
                    <vs-button
                        class="mt-3 w-auto"
                    >Import Number</vs-button>
                </div>
            </div>
            <div class="table_side mb-12">
              <ag-grid-vue
                class="ag-theme-material w-100 my-4 ag-grid-table ag-grid-border"
                id="myGrid"
                :gridOptions="gridOptions"
                :columnDefs="columnDefs"
                :autoGroupColumnDef="autoGroupColumnDef"
                :floatingFilter="true"
                :defaultColDef="defaultColDef"
                :suppressRowClickSelection="true"
                :groupSelectsChildren="true"
                :rowSelection="rowSelection"
                :rowGroupPanelShow="rowGroupPanelShow"
                :enableRangeSelection="true"
                :pagination="true"
                :suppressPaginationPanel="true"
                :paginationPageSize="paginationPageSize"
                :rowData="list"
                :enableRtl="$vs.rtl"
                ></ag-grid-vue>
            </div>
            <vs-pagination
            :total="totalPages"
            :max="maxPageNumbers"
            v-model="currentPage" />
            </vx-card>
  </div>
</template>

<script>
import TableMixin from '@/mixins/table.js'

// Packages
import { AgGridVue } from 'ag-grid-vue';
// import 'ag-grid-enterprise';
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-alpine.css';
import '@/assets/scss/vuexy/extraComponents/agGridStyleOverride.scss'
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import VueApexCharts from 'vue-apexcharts'
import StatisticsCardLine from '@/views/admin/dashboard/StatisticsCardLine.vue'
import analyticsData from '@/views/admin/dashboard/analyticsData.js'
import ChangeTimeDurationDropdown from '@/views/admin/dashboard/ChangeTimeDurationDropdown.vue'

export default {
     mixins: [TableMixin],
  components: {
    AgGridVue,
    VueApexCharts,
    StatisticsCardLine,
    VuePerfectScrollbar,
    ChangeTimeDurationDropdown
  },
  data () {
    return {
       gridOptions: null,
       columnDefs: null,
       autoGroupColumnDef: null,
       defaultColDef: null,
       rowSelection: null,
       rowGroupPanelShow: null,
       pivotPanelShow: null,
       rowData: null,
       gridApi:null,
       maxPageNumbers:null
    };
    // return {
    //   rowSelection: null,
    //   subscribersGained: {},
    //   revenueGenerated: {},
    //   quarterlySales: {},
    //   ordersRecevied: {},

    //   revenueComparisonLine: {},
    //   goalOverview: {},

    //   browserStatistics: [],
    //   clientRetentionBar: {},

    //   sessionsData: {},
    //   chatLog: [],
    //   chatMsgInput: '',
    //   customersData: {},

    //   analyticsData,
    //   settings: {
    //     maxScrollbarLength: 60,
    //     wheelSpeed: .60
    //   }
    // }
  },
  beforeMount() {
    this.gridOptions = {};
    this.columnDefs = [
      {
        headerName: 'Number',
        field:'number',
        filter: 'agTextColumnFilter',
      },
      {
        headerName: 'Setup Fee',
        field: 'setup_fee',
        // minWidth: 180,
        headerCheckboxSelection: true,
        headerCheckboxSelectionFilteredOnly: true,
        checkboxSelection: true,
        filter: 'agTextColumnFilter',
      },
      {
        headerName: 'MRC',
        field: 'mrc',
        filter: 'agTextColumnFilter',
      },
      {
        headerName:'Start On',
        field: 'start_on',
        filter: 'agTextColumnFilter',
      },
      {
        headerName: 'Country',
        field: 'country',
        filter: 'agTextColumnFilter',
      },
      {
        headerName: 'State',
        field: 'state',
        filter: 'agTextColumnFilter',
      },
      {
        headerName: 'LATA',
        field: 'lata',
        filter: 'agTextColumnFilter',
      },
      {
        headerName: 'status',
        field: 'udf2',
        filter: 'agTextColumnFilter',
      },
      {
        headerName: 'On-net',
        field: 'udf3',
        filter: 'agTextColumnFilter',
      }
    ];

    this.autoGroupColumnDef = {
      headerName: 'Group',
      minWidth: 170,
      field: 'athlete',
      valueGetter: (params) => {
        if (params.node.group) {
          return params.node.key;
        } else {
          return params.data[params.colDef.field];
        }
      },
      headerCheckboxSelection: true,
      cellRenderer: 'agGroupCellRenderer',
      cellRendererParams: { checkbox: true },
    };
    this.defaultColDef = {
      editable: true,
      enableRowGroup: true,
      enablePivot: true,
      enableValue: true,
      sortable: true,
      resizable: true,
      filter: true,
      flex: 1,
      minWidth: 100,
    };
    this.rowSelection = 'multiple';
    this.rowGroupPanelShow = 'always';
    this.pivotPanelShow = 'always';
  },
  mounted() {
    this.gridApi = this.gridOptions.api;
    this.gridApi.sizeColumnsToFit()
    // fetch('https://www.ag-grid.com/example-assets/olympic-winners.json')
    //     .then((resp) => resp.json())
        // .then((data) =>  this.rowData = data);
  },
  created(){
      this.GetList()
  },
  methods: {
    openNumberPage () {
     this.$router.push({name: 'company-admin-number-listing-did-buy-number'})
    },
      GetList () {
        this.$vs.loading()
        this.$store.dispatch('didcompany/GetList', {
        ...this.filters,
        page: this.page || 0,
        per_page: this.per_page || 20,
        order_by: this.order_by || 'created_on',
        order_dir: this.order_dir || 'desc',
      })
      .then(res => {
        this.list = res.items.map(this.TransformList)
        this.total = res.total
      })
      .catch(err => this.ShowErrorMessage({ title: 'Error', text: err }))
      .finally(() => this.$vs.loading.close())
      },
      SearchWithField (e, field) {
      if (!e) delete this.filters[field]
      else this.filters[field] = e && e.value

      this.GetList()
    },

    // Notify
    ShowSuccessMessage ({ title, text }) {
      this.$vs.notify({
        iconPack: 'feather',
        icon: 'icon-check',
        color: 'success',
        title,
        text
      })
    },
    ShowErrorMessage ({ title, text }) {
      this.$vs.notify({
        iconPack: 'feather',
        icon: 'icon-alert-circle',
        color: 'danger',
        title,
        text
      })
    },

    // Transform functions
    TransformList(item) {
        console.log(item)
      return {
        refreshData: this.GetList,
        country: item.area.country.name,
        start_on: item.created_on,
        mrc: item.mrc,
        state: item.state,
        lata: item.lata,
        status:item.status,
        on_net: item.on_net,
        number: item.using.did_number
      }
    }
  },
  computed:{
    paginationPageSize () {
      if (this.gridApi) return this.gridApi.paginationGetPageSize()
      else return 10
    },
    currentPage:{
         get () {
        if (this.gridApi) return this.gridApi.paginationGetCurrentPage() + 1
        else return 1
      },
      set (val) {
        this.gridApi.paginationGoToPage(val - 1)
      }

    },
    totalPages () {
      if (this.gridApi) return this.gridApi.paginationGetTotalPages()
      else return 0
    },
  }
}
</script>
<style>
.contact_page{
    margin-top: 60px;
    width: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
}
.contact_page_item{
    width: 90%;
}
    .header_side{
        width: 100%;
        display: flex;
        justify-content: space-between;
        margin-bottom: 25px;
    }
    .header_side_buttons>button{
        width: 150px;
        height: 40px;
        background-color: #7367EC;
        border: none;
        color: white;
        border-radius: 7px;
        margin-right: 10px;
    }
</style>
